import { Box, Grid, GridItem, useToast } from '@chakra-ui/react'
import { ModalFormaPagamento } from './components/Modais/ModalFormaPagamento'
import { DropdownCheckbox } from '../../../components/DropdownCheckbox'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'

async function updateEmpresa({ numero_nota, id_empresa }) {
    const response = await api.put('/site/v2/orcamento-crm/atualiza-empresa-orcamento', {
        numero_nota,
        id_empresa,
    })

    return response.data
}

async function updateVerba({ numero_nota, id_verba }) {
    const response = await api.put('/site/v2/orcamento-crm/atualiza-tipo-verba', {
        numero_nota,
        id_verba,
    })

    return response.data
}

async function updateSt({ numero_nota, id_tipo, tipo_uso }) {
    const response = await api.put('/site/v2/orcamento-crm/atualiza-tipo-uso', {
        numero_nota,
        id_tipo,
        tipo_uso,
    })

    return response.data
}

async function updateFunil({ numero_nota, id_funil }) {
    const response = await api.put('/site/v2/orcamento-crm/atualiza-funil-vendas', {
        numero_nota,
        id_funil,
    })

    return response.data
}

export function SelectsHeader({ infoProposta, itens }) {
    const queryClient = useQueryClient()
    const { numeroProposta: numProposta } = useParams()
    const { pedidoBloqueado } = useOrcamentoPedido()

    const toast = useToast({
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const {
        mutateAsync: onUpdateEmpresa,
        isLoading: isLoadingUpdateEmpresa,
        isError: isErrorEmpresa,
    } = useMutation({
        mutationFn: updateEmpresa,
        onSuccess: (data) => {
            queryClient.setQueryData(['items', numProposta], (oldData) => {
                return {
                    ...oldData,
                    informacao_da_proposta: {
                        ...oldData.informacao_da_proposta,
                        codigo_empresa: data.id_empresa,
                    },
                }
            })

            toast({
                title: 'Empresa atualizada com sucesso',
                status: 'success',
            })
        },
    })


    const {
        mutateAsync: onUpdateFunil,
        isLoading: isLoadingUpdateFunil,
        isError: isErrorFunil,
    } = useMutation({
        mutationFn: updateFunil,
        onSuccess: (data) => {
            queryClient.setQueryData(['items', numProposta], (oldData) => {
                return {
                    ...oldData,
                    informacao_da_proposta: {
                        ...oldData.informacao_da_proposta,
                        id_funil: data.id_funil,
                    },
                }
            })

            toast({
                title: 'Funil de vendas atualizado com sucesso',
                status: 'success',
            })
        },
    })

    const {
        mutateAsync: onUpdateVerba,
        isLoading: isLoadingUpdateVerba,
        isError: isErrorVerba,
    } = useMutation({
        mutationFn: updateVerba,
        onSuccess: (data) => {
            queryClient.setQueryData(['items', numProposta], (oldData) => {
                return {
                    ...oldData,
                    informacao_da_proposta: {
                        ...oldData.informacao_da_proposta,
                        id_verba: data.id_verba,
                        valida_proposta_nova: data.valida_proposta_nova,
                    },
                }
            })

            toast({
                title: 'Verba atualizado com sucesso',
                status: 'success',
            })
        },
    })

    const {
        mutateAsync: onUpdateSt,
        isLoading: isLoadingUpdateSt,
        isError: isErrorSt,
    } = useMutation({
        mutationFn: updateSt,
        onSuccess: (data) => {
            queryClient.setQueryData(['items', numProposta], (oldData) => {
                return {
                    ...oldData,
                    informacao_da_proposta: {
                        ...oldData.informacao_da_proposta,
                        id_tipo: data.id_tipo,
                        valida_proposta_nova: data.valida_proposta_nova,
                    },
                }
            })

            toast({
                title: 'Verba atualizado com sucesso',
                status: 'success',
            })
        },
    })

    async function handleUpdateFunil({ value }) {
        const { value: idFunil } = value
        await onUpdateFunil({
            numero_nota: infoProposta?.num_proposta,
            id_funil: idFunil,
        })
    }

    async function handleUpdateEmpresa({ value }) {
        const { value: idEmpresa } = value

        await onUpdateEmpresa({
            numero_nota: infoProposta?.num_proposta,
            id_empresa: idEmpresa,
        })
    }

    async function handleUpdateVerba({ value }) {
        const { value: idVerba } = value
        await onUpdateVerba({
            numero_nota: infoProposta?.num_proposta,
            id_verba: idVerba,
        })
    }

    async function handleUpdateSt({ value }) {
        const { value: idTipo, label } = value
        await onUpdateSt({
            numero_nota: infoProposta?.num_proposta,
            id_tipo: idTipo,
            tipo_uso: label,
        })
    }

    return (
        <Grid gap={2} templateColumns="repeat(5, 1fr)" maxW="1000px" w="full" textTransform="initial" pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
            <GridItem>
                <ModalFormaPagamento formasPagamento={infoProposta?.formas_pagamento} defaultValue={infoProposta?.id_pagamento} numeroNota={infoProposta?.num_proposta} />
            </GridItem>
            <Box p={1} bg="#EDF2F7">
                <DropdownCheckbox
                    px={1}
                    label="Empresa"
                    options={infoProposta?.empresas}
                    onConfirm={handleUpdateEmpresa}
                    defaultValue={infoProposta?.codigo_empresa}
                    isLoading={isLoadingUpdateEmpresa}
                    close={!isLoadingUpdateEmpresa && !isErrorEmpresa}
                />
            </Box>
            <Box p={1} bg="#EDF2F7">
                <DropdownCheckbox
                    px={1}
                    label="Funil de Vendas"
                    options={infoProposta?.tipos_funil}
                    onConfirm={handleUpdateFunil}
                    defaultValue={infoProposta?.id_funil}
                    isLoading={isLoadingUpdateFunil}
                    close={!isLoadingUpdateFunil && !isErrorFunil}
                    isReadOnly={true}
                />
            </Box>
            <Box p={1} bg="#EDF2F7">
                <DropdownCheckbox
                    px={1}
                    label="Verba"
                    options={infoProposta?.tipos_verba}
                    onConfirm={handleUpdateVerba}
                    defaultValue={parseInt(infoProposta?.id_verba)}
                    isLoading={isLoadingUpdateVerba}
                    close={!isLoadingUpdateVerba && !isErrorVerba}
                />
            </Box>
            <Box p={1} bg="#EDF2F7">
                <DropdownCheckbox
                    px={1}
                    label="Uso ST"
                    options={infoProposta?.info_tipo}
                    onConfirm={handleUpdateSt}
                    defaultValue={parseInt(infoProposta?.id_tipo)}
                    isLoading={isLoadingUpdateSt}
                    close={!isLoadingUpdateSt && !isErrorSt}
                    maxW="120px"
                />
            </Box>
        </Grid>
    )
}
